module.exports = __webpack_public_path__ + "media/images/emblems/Saanen-coat_of_arms-e3e73d2ad5da28b32f5d3b269a3eb8b2.svg";